<template>
  <div class="w-[95%] mx-auto my-[20px]">
    <div v-if="isLoading">Loading</div>
    <slot v-if="!isLoading && invoice">
      <invoice-content :data="invoice" />
    </slot>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { Get } from '@/api/invoice';
import { notify } from 'notiwind';

import InvoiceContent from '@/components/order/InvoiceContent.vue';

const invoice = ref({});
const route = useRoute();

const isLoading = ref(false);

onMounted(async () => {
  try {
    isLoading.value = true;

    const { data: { data } } = await Get(route.params?.id ?? 'id-is-null');
    invoice.value = data;
  } catch (error) {
    let message;
    if (error.response) {
      message = error.response.data.message;
    }
    message = message ?? 'An error occured while loading the invoice';
    notify(
      {
        variant: 'bg-red-700',
        group: 'foo',
        text: message,
      },
      5000,
    );
  } finally {
    isLoading.value = false;
  }
});
</script>
